import {
  Button,
  IconButton,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { BootstrapInput } from "../../../Utilities/utility";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useState, useEffect, useCallback } from "react";
import "../Standard-MLFB/standard-mlfb.css";
import SnackbarCustom from "../../../components/Snackbar/Snackbar";
import { useSelector, useDispatch } from "react-redux";
import {
  getNonStdMLFBData,
  getCategory,
  getSubCategory,
  getZCode,
  deleteNonStandarsMLFB,
  SearchGetNonStandardMLFB,
  createNonStandardMLFB,
  editNonStandardMLFB,
  GetDataToEditNonStandardMLFB,
} from "../../../redux/API/api_nonStandardMlfb";
import * as XLSX from "xlsx";
import NonStandardMLFBDialog from "./non-standard-mlfb-dialog";
import { zcodesData } from "../../../redux/Actions/actions";

export default function NonStandardMLFb() {
  const [editNonStdMlfb, setEditNonStdMlfb] = useState(false);
  const [rows, setRows] = useState([]);
  const [initialRows, setInitialRows] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const UID = useSelector((state) => state.saveUserIdReducer);
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);
  const [openForDelete, setOpenForDelete] = useState(false);
  const [deleteUser, setDeleteUser] = useState([]);
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [subCategoryId, setSubCategoryId] = useState("");
  const [zCode, setZCode] = useState([]);
  const [zCodeId, setZCodeId] = useState("");
  const [parentCategoryId, setParentCategoryId] = useState("");
  const dispatch = useDispatch();

  const columns = [
    { field: "category", headerName: "Category", width: 200, sortable: true },
    { field: "subCategory", headerName: "Sub Category", width: 200 },
    { field: "zCodeValue", headerName: "Z Code Description", width: 250 },
    { field: "zcode", headerName: "Z Code", width: 250 },
    { field: "deviationType", headerName: "Deviation Type", width: 200 },
    { field: "deviation", headerName: "Deviation", width: 200 },

    {
      field: "action",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      width: "100px",

      renderCell: (params) => (
        <div>
          <IconButton
            color="primary"
            onClick={() => handleEditNonStdMlfb(params.row)}
          >
            <EditIcon style={{ cursor: "pointer" }} />
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </div>
      ),
    },
  ];
  useEffect(() => {
    getTableData();
    getCategoryDropDownValue();

    //getZcodeDropDownValue()
  }, []);

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  //on Load table listing
  function getTableData() {
    setIsLoader(true);
    let input = {};
    input.CategoryId = null;

    getNonStdMLFBData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.roleName,
      userdetails.gid,
      userdetails.roleId,
      input
    )
      .then((response) => {
        setInitialRows(response);
        dispatch(zcodesData(response));
        console.log("rows", rows);
        setRows(response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  // category dropdown data
  function getCategoryDropDownValue() {
    setIsLoader(true);
    getCategory(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId
    )
      .then((response) => {
        console.log("category", response);
        setCategory(response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  //sub Category dropdown

  function getSubCategoryDropDownValue(categoryId) {
    setIsLoader(true);
    getSubCategory(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      categoryId
    )
      .then((response) => {
        console.log("Subcategory", response);
        setSubCategory(response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  // zcode dropdown

  function getZcodeDropDownValue(subCategorypPartId) {
    setIsLoader(true);
    getZCode(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      subCategorypPartId
    )
      .then((response) => {
        console.log("z-code", response);
        setZCode(response);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  const categoryDropdownChange = (e) => {
    const categoryId = e.target.value;
    setCategoryId(categoryId);
    getSubCategoryDropDownValue(categoryId);
  };

  const subCategorydropdownChange = (e) => {
    const subCategoryId = e.target.value;
    if (subCategory?.length > 0) {
      const selectObject = subCategory.find(
        (item) => item.subcatparentid === parseInt(subCategoryId)
      );

      if (selectObject) {
        console.log("Selected Object for nonstad searrching:", selectObject);

        setParentCategoryId(selectObject.subcatparentid);
        setSubCategoryId(subCategoryId);
        getZcodeDropDownValue(selectObject.subcatparentid);
      }
    }
  };

  const zCodeDropdownChange = (e) => {
    const zCodeId = e.target.value;
    console.log(zCodeId);
    setZCodeId(zCodeId);
  };

  const handleEditNonStdMlfb = (editData) => {
    setEditNonStdMlfb(editData);
    setOpenDialog(true);
  };

  //dropdown search//

  const handleSearChange = () => {
    setIsLoader(true);
    let input = {};
    input.CategoryId = categoryId;
    input.ParentCategoryId = parentCategoryId;
    input.Zcode = "";

    SearchGetNonStandardMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.roleName,
      userdetails.gid,
      userdetails.roleId,
      input
    )
      .then((response) => {
        if (response) {
          setIsLoader(false);
          setRows(response);
          //getTableData();
        } else {
          setIsLoader(false);
        }
      })
      .catch((error) => {
        setIsLoader(false);
      });
  };

  // reset dropdown
  const handleReset = () => {
    setCategoryId("");
    setSubCategoryId("");
    setZCodeId("");
    setRows(initialRows);
  };
  //global search
  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);
    const filteredRows = initialRows.filter((row) =>
      Object.values(row).some((field) =>
        field ? field.toString().toLowerCase().includes(value) : ""
      )
    );
    setRows(filteredRows);
  };
  //reset global search
  const clearSearch = () => {
    setSearchText("");
    setRows(initialRows);
  };

  //downLoad Excel
  const exportToExcel = () => {
    let ExcelData = [];
    console.log("export file", ExcelData);

    if (!rows || rows.length === 0) {
      console.error("No data available for export.");
      return;
    } else {
      for (let i = 0; i < rows?.length; i++) {
        let input = {};
        input.SrNo = i + 1;
        input.Category = rows[i]?.category;
        input.SubCategory = rows[i]?.subCategory;
        input.ZCodeDescription = rows[i]?.zCodeValue;
        input.ZCodeValue = rows[i]?.zcode;
        input.DeviationType = rows[i]?.deviationType;
        input.Deviation = rows[i]?.deviation;

        ExcelData.push(input);
      }
    }
    const worksheet = XLSX.utils.json_to_sheet(ExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Non Standard-MLFB");
    XLSX.writeFile(workbook, "Non Standard-MLFB.xlsx");
  };

  const handleDelete = (nonStdMLFB) => {
    console.log(nonStdMLFB);
    setOpenForDelete(true);
    setDeleteUser(nonStdMLFB);
  };

  const handleCloseforDelete = () => {
    setOpenForDelete(false);
    setDeleteUser([]);
  };

  const handleClose = (e) => {
    setOpen(false);
  };

  const handleRowDelete = () => {
    console.log("deleteUser", deleteUser);
    setIsLoader(true);
    setOpenForDelete(false);
    deleteNonStandarsMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      deleteUser.categoryId
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  const handleAddNonStdMlfb = useCallback(() => {
    setEditNonStdMlfb(null);
    setOpenDialog(true);
  }, []);

  const handleSaveNonStdMlfb = (newUser) => {
    setOpenDialog(false);
    handleRowAdd(newUser);
  };
  const handleRowAdd = (newTableData) => {
    const input = {};
    input.CategoryId = 0;
    input.ZCodeValue = newTableData.ZCodeValue;
    input.subcatparentid = newTableData.subCategoryId;
    input.Deviation = newTableData.Deviation;
    input.DeviationType = newTableData.DeviationTypeId;
    input.Zcode = newTableData.ZcodeName;
    setIsLoader(true);
    createNonStandardMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      input
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  const handleUpdateNonStdMLFB = (newuser) => {
    handleRowUpdate(newuser);
    setOpenDialog(false);
  };
  const handleRowUpdate = (prevData) => {
    console.log(prevData);

    let input = {};
    input.CategoryId = prevData.categoryId;
    input.ZCodeValue = prevData.ZCodeValue;
    input.subcatparentid = prevData.subCategoryChosen;
    input.Deviation = prevData.Deviation;
    input.DeviationType = String(prevData.deviationTypeIdChosen);
    input.Zcode = prevData.Zcode;

    setOpenDialog(false);
    setIsLoader(true);
    editNonStandardMLFB(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      input
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  return (
    <>
      <Box sx={{ padding: "10px", border: "1px solid #ccc" }}>
        <Typography variant="h5" gutterBottom>
          Non Standard MLFB
        </Typography>

        <Grid
          container
          spacing={3}
          style={{ marginTop: "5px", padding: "12px" }}
        >
          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Category
              </InputLabel>
              <Select
                id="categoryId"
                name="category"
                value={categoryId || ""}
                onChange={categoryDropdownChange}
                input={<BootstrapInput />}
                style={{ width: "60%" }}
              >
                {category?.length > 0 ? (
                  category?.map((data) => (
                    <MenuItem key={data.categoryId} value={data.categoryId}>
                      {data.categoryName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>Loading Category...</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Sub Category
              </InputLabel>
              <Select
                id="categoryId"
                name="categoryId"
                value={subCategoryId}
                onChange={subCategorydropdownChange}
                input={<BootstrapInput />}
                style={{ width: "60%" }}
              >
                {subCategory?.length > 0 ? (
                  subCategory
                    .filter((data) => data.subcatparentid) // Filter based on subcatparentid
                    .map((data) => (
                      <MenuItem
                        key={data.subcatparentid}
                        value={data.subcatparentid}
                      >
                        {data.categoryName}
                      </MenuItem>
                    ))
                ) : (
                  <MenuItem disabled>Loading Sub Category...</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <FormControl fullWidth>
              <InputLabel shrink htmlFor="bootstrap-input">
                Z Code
              </InputLabel>
              <Select
                id="zcodeid"
                name="Zcode"
                displayEmpty
                value={zCodeId}
                onChange={zCodeDropdownChange}
                input={<BootstrapInput />}
                style={{ width: "60%" }}
              >
                {zCode?.length > 0 ? (
                  zCode?.map((data) => (
                    <MenuItem key={data.zcodeid} value={data.zcodeid}>
                      {data.zcode}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>Loading ZCode...</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px",
            marginBottom: "20px",
            maxWidth: "none",
          }}
        >
          <Button
            className="btn"
            variant="contained"
            onClick={handleSearChange}
          >
            Search
          </Button>
          <Button className="btn" variant="contained" onClick={handleReset}>
            Reset
          </Button>

          <SearchIcon color="action" />
          <TextField
            variant="standard"
            placeholder="Search"
            value={searchText}
            onChange={handleSearch}
            sx={{ marginLeft: "5px", width: "200px", width: "200px" }}
          />
          <IconButton onClick={clearSearch} size="small">
            <ClearIcon fontSize="small" />
          </IconButton>
          <Tooltip title="Download excel" arrow disableInteractive>
            <IconButton onClick={() => exportToExcel()} size="small">
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <div>
            <Button
              className="btn"
              variant="contained"
              onClick={handleAddNonStdMlfb}
            >
              Add
            </Button>
            <NonStandardMLFBDialog
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              onSave={handleSaveNonStdMlfb}
              onUpdate={handleUpdateNonStdMLFB}
              nonstdToEdit={{ editNonStdMlfb }}
            />
          </div>
        </Box>

        <div
          style={{
            height: 500,
            width: "100%",
            gap: "10px",
            paddingTop: "30px",
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            getRowId={(row) => row.categoryId}
            pageSize={4}
            rowsPerPageOptions={[4]}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "No Matching Records Found!",
            }}
            loading={isLoader}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#d3d3d3",
                fontWeight: "500",
                fontSize: "13px",
                color: "black",
                lineHeight: "1.5rem",
              },
              "& .MuiDataGrid-columnHeader": { backgroundColor: "#d3d3d3" },

              "& .MuiDataGrid-cell": {
                textAlign: "left",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-footerContainer": {
                fontSize: "12px",
              },
            }}
          />
          <>
            <SnackbarCustom
              open={open}
              message={snackMessage}
              alertType={alertType}
              handleClose={handleClose}
            />
          </>
          <Dialog
            open={openForDelete}
            onClose={handleCloseforDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete the Non standard MLFB?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseforDelete}
                className="pt-button--secondary"
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleRowDelete()}
                className="pt-button--primary"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Box>
    </>
  );
}
